/**
 * 池长路由
 */
const JieshuiRouter = {
  path: 'jieshui',
  name: 'Jieshui',
  meta: {
    requiresAuth: false,
    leftMenu: true          // false表示不需要左边菜单栏
  },
  component: () => import('@/views/Jieshui/index')
}
export default JieshuiRouter
